import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

interface Avatar {
    name: string;
    imageUrl: string;
    selected: boolean;
}

@Component({
    selector: 'app-user-avatar-dialog',
    templateUrl: './userAvatar-dialog.component.html',
    styleUrls: ['./userAvatar-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
    ],
})
export class UserAvatarDialogComponent {
    avatars: Avatar[] = [
        { name: 'Student 1', imageUrl: 'https://trexstagestorage.blob.core.windows.net/trex-images/student-avatars/avatar.jpg', selected: false },
        { name: 'Student 2', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSheE2LxgJpFhvuvVZ_2Es4bZLbAO7KcCsZlQ&s', selected: false },
        { name: 'Student 3', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBT0nlxL0IrspWt7F-OtzLl2OrJPLaOUOiaw&s', selected: false },
        { name: 'Student 4', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgcHd2vsufAPeqYR2CcXdIXKbmLo5dr2kARw&s', selected: false },
        { name: 'Student 5', imageUrl: 'https://static.vecteezy.com/system/resources/previews/053/537/859/non_2x/cartoon-boy-with-green-shirt-on-transparent-background-free-png.png', selected: false },
    ];

    constructor(private dialogRef: MatDialogRef<UserAvatarDialogComponent>) { }

    selectAvatar(selectedAvatar: Avatar): void {
        this.avatars.forEach(avatar => avatar.selected = false);
        selectedAvatar.selected = true;
    }

    closeDialog(): void {
        const selectedAvatar = this.avatars.find(a => a.selected);
        this.dialogRef.close(selectedAvatar);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    get hasSelectedAvatar(): boolean {
        return this.avatars.some(a => a.selected);
    }
}